import Taxs from ".";

export const taxRoutes = (data) => [
  {
    path: "/admin/tax",
    title: "tax",
    layout: "admin",
    routeType: "admin",
    component: Taxs,
  },
];
